import * as React from "react"
import { useFlags } from "launchdarkly-react-client-sdk"
import * as styles from "./styles.css"

// this route wraps all `site/:siteId/data-layer/` routes
export function DataLayerRoot({ children }: { children: React.ReactNode }) {
  const flags = useFlags()
  if (!flags.acceleratedSourcingForProductionBuilds) return null

  return <div className={styles.root}>{children}</div>
}
